const startTimer = (() => {
  const config = {
    get triggers() {
      return this.triggerCN
        .map(CN => [...document.querySelectorAll(`.${CN}`)])
        .reduce((acc, current) => [...acc, ...current]);
    },
    triggerCN: ['js-time']
  };

  const build = () => {
    config.triggers.forEach(trigger => {
      const display = trigger;
      const duration = trigger.innerHTML;
      const parts = duration.split(':');
      const partsMinutes = +parts[0];
      const partsSeconds = +parts[1];
      const durationResult = parseInt(partsMinutes) * 60 + parseInt(partsSeconds);

      function startTimer(duration) {
        let timer = duration, minutes, seconds;
        setInterval(function () {
          minutes = parseInt(timer / 60, 10);
          seconds = parseInt(timer % 60, 10);

          minutes = minutes < 10 ? '0' + minutes : minutes;
          seconds = seconds < 10 ? '0' + seconds : seconds;

          display.textContent = minutes + ':' + seconds;

          if (--timer < 0) {
            timer = duration;
          }
        }, 1000);
      }
      startTimer(durationResult);
    });
  };

  const init = () => {
    if (config.triggers.length > 0) {
      build();
    }
  };

  return {
    init,
  };
})();

export default startTimer.init()